import {
    API,
    graphqlOperation
} from "aws-amplify";
import {
    ListUserOrganizationAssociationsByUserAndAssociationTypeQuery,
    ListUserOrganizationAssociationsByUserAndAssociationTypeQueryVariables
} from "../../../API";
import {
    UserOrganizationAssociation,
    UserOrganizationAssociationType,
    UserOrganizationRole
} from "../../../models";

import ClientLogger from "../../logging/ClientLogger";
import DataStoreUserOrganizationAssociationDAO from "../DataStoreUserOrganizationAssociationDAO";
import { GraphQLResult } from "@aws-amplify/api-graphql";
import { IDTokenSupplier } from "../../auth/IDTokenSupplier";
import UserOrganizationAssociationDAO from "../UserOrganizationAssociationDAO";
import { listUserOrganizationAssociationsByUserAndAssociationType } from "../../../graphql/queries";

export default class GraphQLUserOrganizationAssociationDAO implements UserOrganizationAssociationDAO {
    public static USER_ORGANIZATION_ASSOCIATION_CREATION_ATTEMPT = "GraphQLUserOrganizationAssociationDAO.Create.Attempt";
    public static USER_ORGANIZATION_ASSOCIATION_CREATION_FAILURE = "GraphQLUserOrganizationAssociationDAO.Create.Failure";
    public static USER_ORGANIZATION_ASSOCIATION_RETRIEVAL_ATTEMPT = "GraphQLUserOrganizationAssociationDAO.Retrieval.Attempt";
    public static USER_ORGANIZATION_ASSOCIATION_RETRIEVAL_FAILURE = "GraphQLUserOrganizationAssociationDAO.Retrieval.Attempt";

    private readonly api: typeof API;
    private readonly gqlOperation: typeof graphqlOperation;
    private readonly logger: ClientLogger;
    private readonly idTokenSupplier: IDTokenSupplier;

    constructor(
        api: typeof API,
        gqlOperation: typeof graphqlOperation,
        logger: ClientLogger,
        idTokenSupplier: IDTokenSupplier
    ) {
        this.api = api;
        this.gqlOperation = gqlOperation;
        this.logger = logger;
        this.idTokenSupplier = idTokenSupplier;
    }

    public async listUserOrganizationAssociationsByUserId(
        userId: string
    ): Promise<UserOrganizationAssociation[]> {
        try {
            this.logger.info(
                `Attempting to retrieve userOrganizationAssociation by userId: ${userId}`,
                undefined,
                [DataStoreUserOrganizationAssociationDAO.USER_ORGANIZATION_ASSOCIATION_RETRIEVAL_ATTEMPT]
            );
             const variables: ListUserOrganizationAssociationsByUserAndAssociationTypeQueryVariables = {
                userId: userId
            };
            const authToken: string = await this.idTokenSupplier.get();
            const result = await this.api.graphql(this.gqlOperation(
                listUserOrganizationAssociationsByUserAndAssociationType,
                variables,
                authToken
            )) as GraphQLResult<ListUserOrganizationAssociationsByUserAndAssociationTypeQuery>;
            return (result.data?.listUserOrganizationAssociationsByUserAndAssociationType?.items ?? []) as Array<UserOrganizationAssociation>;
        } catch (error) {
            this.logger.error(
                `Failed to retrieve userOrganizationAssociation by userId: ${userId}`,
                error,
                [DataStoreUserOrganizationAssociationDAO.USER_ORGANIZATION_ASSOCIATION_RETRIEVAL_FAILURE]
            );
            throw new Error("Failed to retrieve UserOrganizationAssociations");
        }
    }

    public async createUserOrganizationAssociation(
        userId: string,
        organizationId: string,
        associationType: UserOrganizationAssociationType,
        role?: UserOrganizationRole | undefined
    ): Promise<UserOrganizationAssociation> {
        throw new Error("Method not implemented.");
    }
}
